import { useChainId } from 'wagmi'
import { getStaking2aAddress } from '@/config/get-staking2a-address'
import { NetworkId } from '@/types/network'

/**
 * Fetches the address of the Staking2a contract according to the current chain
 * @returns The address of the Staking2a contract
 */
export function useStaking2aAddress() {
	const chainId = useChainId()

	return getStaking2aAddress(chainId as NetworkId)
}
